// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FinancialBenefitsAddContainer_wrap__10BEe","title":"FinancialBenefitsAddContainer_title__2e5Ob"};